import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import useResizeObserver from 'use-resize-observer'
import moment from 'moment'
// icons
import ChevronLeftIcon from '../../icons/ChevronLeftIcon'
import ChevronRightIcon from '../../icons/ChevronRightIcon'
import CalendarIcon from '../../icons/CalendarIcon'
// styles
import './time-table.scss'

/**
 * Adiciona minutos em um horário em formato 'HH:mm' ou 'HH:mm:ss'.
 */
const addMinutes = (time, minsToAdd) => {
  function D(J){ return (J<10? '0':'') + J;}
  var piece = time.split(':')
  var mins = piece[0]*60 + +piece[1] + +minsToAdd
  return D(mins%(24*60)/60 | 0) + ':' + D(mins%60)
}

function TimeTable(props) {

  const {
    inLine,
    limitDays,
    limitDate,
    eventMinutes,
    weekIntervals,
    existingEvents,
    delayMinutes,
    maxBodyHeight,
    showFooter,
    onSelect,
    onMore
  } = props

  const [currentWidth, setCurrentWidth] = useState(null)
  const [index, setIndex] = useState(0)
  const [pageSize, setPageSize] = useState(1)
  const [list, setList] = useState({})
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    // console.log('useEffect', limitDays, eventMinutes, weekIntervals, existingEvents)
    const now = new Date()
    const startDate = moment(now).format('YYYY-MM-DD')
    let endDate = null
    if (limitDate) {
      // utilizado quando há data limite para retorno (acrescenta um dia para incluir o do dia limite)
      endDate = moment(limitDate).add(1, 'days').format('YYYY-MM-DD')
    } else {
      // padrão 60 dias a frente
      endDate = moment(now).add(limitDays, 'days').format('YYYY-MM-DD')
    }

    // ["2020-07-02", "2020-07-03", "2020-07-04", "2020-07-05", "2020-07-06", ...]
    const dates = getDates(startDate, endDate)
    // console.log('dates', dates)

    // {
    //   2: [
    //     {start: "08:00", end: "09:00", state: "free"}
    //     {start: "09:00", end: "10:00", state: "free"}
    //     {start: "10:00", end: "11:00", state: "free"}
    //   ]
    // }
    const hoursIntervalsByWeekDay = getHoursIntervalsByWeekDay()
    // console.log('hoursIntervalsByWeekDay', hoursIntervalsByWeekDay)

    const listDates = proccessAvailableDates(dates, hoursIntervalsByWeekDay, existingEvents)
    // console.log('listDates', listDates)
    setIndex(0)
    setList(listDates)
    setLoaded(true)
  }, [])


  const { ref } = useResizeObserver({
    onResize: ({ width, height }) => {
      if (width !== currentWidth) {
        let columns = 1
        if (width > 1440) columns = 14
        else if (width > 1024) columns = 10
        else if (width > 920) columns = 9
        else if (width > 820) columns = 8
        else if (width > 720) columns = 7
        else if (width > 620) columns = 6
        else if (width > 520) columns = 5
        else if (width > 420) columns = 4
        else if (width > 320) columns = 3
        else if (width > 260) columns = 2
        setCurrentWidth(width)
        setPageSize(columns)
        setIndex(0)
      }
    },
  })


  const getDates = (startDate, endDate) => {
    let result = []
    for (var m = moment(startDate); m.isBefore(endDate); m.add(1, 'days')) {
      result.push(m.format('YYYY-MM-DD'))
    }
    return result
  }

  const getHoursIntervalsByWeekDay = () => {
    let result = {}
    for (const item of weekIntervals) {
      // console.log('item', item)
      const day = item.day
      const start = item.start
      const end = item.end
      if (!(day in result)) result[day] = []
      let currentStart = start
      while (currentStart < end) {
        const currentEnd = addMinutes(currentStart, eventMinutes)
        // console.log('day', day, 'currentStart', currentStart, 'currentEnd', currentEnd)
        if (currentEnd <= end) {

          result[day].push({ start: currentStart, end: currentEnd, state: 'free' })
        }
        currentStart = currentEnd
      }
    }
    return result
  }

  const proccessAvailableDates = (dates, hoursIntervalsByWeekDay, existingEvents) => {
    const nowStr = moment(new Date()).add(delayMinutes, 'minutes').format('YYYY-MM-DDTHH:mm')

    const all = {}
    for (const date of dates) {
      const weekDay = moment(date).day() + 1 // agenda do médico começa de 1 [1,2,3,4,5,6,7]
      // adiciona apenas dias que o médico trabalha
      const hoursIntervalsWeekDay = hoursIntervalsByWeekDay[weekDay]
      const intervalsOfDay = (hoursIntervalsWeekDay) ? [...hoursIntervalsByWeekDay[weekDay]] : []
      // percorre todos intervalos de data do dia para verificar se já esta ocupado ou se já passou
      const indexToRemove = []
      for (let i = 0; i < intervalsOfDay.length; i++) {
        const interval = intervalsOfDay[i]
        const intervalStartStr = `${date}T${interval.start}`
        const intervalEndStr = `${date}T${interval.end}`

        // remove datas passadas
        if (intervalEndStr <= nowStr && !indexToRemove.includes(i)) indexToRemove.push(i)

        const events = [...existingEvents]

        // adiciona evento de bloqueio a partir de limitDate até x para impedir agendamento a partir desta data (ex: limite para retorno)
        if (limitDate) {
          events.push({
            start: moment.utc(limitDate).format('YYYY-MM-DDTHH:mm'),
            end: moment.utc(limitDate).add(limitDays, 'days').format('YYYY-MM-DDTHH:mm')
          })
        }

        // remove datas que fazem interseção com eventos existentes
        for (const event of events) {
          // interval   0~~~~~~~~0
          // evento          0~~~~~~~~~~~~~0
          if (intervalEndStr > event.start && intervalEndStr <= event.end && !indexToRemove.includes(i)) {
            indexToRemove.push(i)
          }

          // interval                  0~~~~~~~~0
          // evento          0~~~~~~~~~~~~~0
          if (intervalStartStr >= event.start && intervalStartStr < event.end && !indexToRemove.includes(i)) {
            indexToRemove.push(i)
          }

          // interval        0~~~~~~~~~~~~~0
          // evento          0~~~~~~~~~~~~~0
          if (intervalStartStr == event.start && intervalEndStr == event.end && !indexToRemove.includes(i)) {
            indexToRemove.push(i)
          }
        }
      }

      // remove de traz p frente pois cada remoção reindexa todo o array
      // indexToRemove.reverse().forEach(index => intervalsOfDay.splice(index, 1))
      indexToRemove.sort((a, b) => (a - b)).reverse().forEach(index => intervalsOfDay.splice(index, 1))
      // só adiciona se houver horários disponíveis
      if (intervalsOfDay && intervalsOfDay.length) all[date] = intervalsOfDay
    }
    // console.log('ALL', all)
    return all
  }

  const prevPage = () => {
    setIndex(index - pageSize)
  }

  const nextPage = () => {
    setIndex(index + pageSize)
  }

  const getWeekDayLabel = (date) => {
    const today = moment().endOf('day').format('YYYY-MM-DD')
    const tomorrow = moment().add(1, 'day').endOf('day').format('YYYY-MM-DD')
    if (date === today) return 'Hoje'
    if (date === tomorrow) return 'Amanhã'
    const weekDay = moment(date).day()
    const daysLabel = {
      '0': 'Dom.',
      '1': 'Seg.',
      '2': 'Ter.',
      '3': 'Qua.',
      '4': 'Qui.',
      '5': 'Sex.',
      '6': 'Sab.',
    }
    return daysLabel[String(weekDay)]
  }

  const getMonthDayLabel = (date, long) => {
    const day = Number(moment(date).format('DD')) // Number remove zero left
    const month = moment(date).month()
    const monthsLabel = {
      '0':  (long) ? 'Janeiro' : 'Jan',
      '1':  (long) ? 'Fevereiro' : 'Fev',
      '2':  (long) ? 'Março' : 'Mar',
      '3':  (long) ? 'Abril' : 'Abr',
      '4':  (long) ? 'Maio' : 'Mai',
      '5':  (long) ? 'Junho' : 'Jun',
      '6':  (long) ? 'Julho' : 'Jul',
      '7':  (long) ? 'Agosto' : 'Ago',
      '8':  (long) ? 'Setembro' : 'Set',
      '9':  (long) ? 'Outubro' : 'Out',
      '10': (long) ? 'Novembro' : 'Nov',
      '11': (long) ? 'Dezembro' : 'Dez',
    }
    return day + (long ? ' de ' : ' ') + monthsLabel[month]
  }

  const renderHours = (obj, indexColumn, limit) => {
    const result = []
    for (let i = 0; i < obj.hours.length; i++) {
      const item = obj.hours[i];
      result.push(
        <div
          key={`${indexColumn}-${i}`}
          className={`hour ${item.state}`}
          onClick={() => onSelect(`${obj.date}T${item.start}`)}
        >
          {item.start}
        </div>
      )
      if (limit &&  i >= limit) break
    }
    return result
  }

  // processa janela a ser exibida
  const range = []
  const keys = Object.keys(list)
  for (let i = index; i < (index + pageSize); i++) {
    const key = keys[i]
    if (!key) break
    range.push({
      date: key,
      hours: list[key]
    })
  }

  return (
    <div className="TimeTable" ref={ref}>
      {!loaded || !range.length ?
        <div className="empty-message">Nenhum horário disponível!</div> :
        <>
          <div className={inLine ? 'time-table-inline' : 'time-table'} >
            {inLine ?
              <div className="time-table-inline" ref={ref}>
                <div className="label"><CalendarIcon /><label>Próxima data: </label><span>{getWeekDayLabel(range[0].date)}, {getMonthDayLabel(range[0].date, true)}</span></div>
                <div className="hours">
                  {range.length ?
                    <>
                      {renderHours(range[0], 1, 5)}
                      <div
                        className="more free"
                        onClick={onMore}
                      >
                        <span>Mais <ChevronRightIcon /></span>
                      </div>
                    </> :
                    <div className="enpty-message">
                      Nenhum horário disponível
                    </div>
                  }
                </div>
              </div> :
              <>
                <div className="header">
                  <div className="paginator prev">
                    <button
                      icon="true"
                      onClick={prevPage}
                      disabled={(index === 0) ? true : false}
                    >
                      <ChevronLeftIcon />
                    </button>
                  </div>
                  {range.map((item, index) =>
                    <div className="column" key={`header-${index}`}>
                      <div className="date">
                        <span className="weekDay">{getWeekDayLabel(item.date)}</span>
                        <span className="monthDay">{getMonthDayLabel(item.date)}</span>
                      </div>
                    </div>
                  )}
                  <div className="paginator next">
                    <button
                      icon="true"
                      onClick={nextPage}
                      disabled={(index + pageSize) > Object.keys(list).length}
                    >
                      <ChevronRightIcon />
                    </button>
                  </div>
                </div>
                <div className="body" {...(maxBodyHeight) ? {style: {maxHeight: maxBodyHeight}} : {}}>
                  <div className="paginator prev"></div>
                  {range.map((item, index) =>
                    <div className="column" key={`body-${index}`}>
                      {renderHours(item, index)}
                    </div>
                  )}
                  <div className="paginator next"></div>
                </div>
                {showFooter ?
                  <div className="footer">
                    Horário de Brasília (GMT-3)
                  </div>
                  : null
                }
              </>
            }
          </div>
        </>
      }
    </div>
  )
}

TimeTable.propTypes = {
  inLine: PropTypes.bool,
  limitDays: PropTypes.number,
  limitDate: PropTypes.instanceOf(Date),
  eventMinutes: PropTypes.number,
  weekIntervals: PropTypes.array,
  existingEvents: PropTypes.array,
  maxBodyHeight: PropTypes.number,
  showFooter: PropTypes.bool,
  onSelect: PropTypes.func,
  onMore: PropTypes.func,
}

TimeTable.defaultProps = {
  inLine: false,
  limitDays: 60,
  limitDate: null, // se informado apresenta até esta data, se não limita por limitDays
  eventMinutes: 45,
  showFooter: true,
  weekIntervals: [/*{
    day: 4,
    start: '08:00',
    end: '17:00'
  }, {
    day: 5,
    start: '08:00',
    end: '12:00'
  }, {
    day: 5,
    start: '13:30',
    end: '17:00'
  }, {
    day: 6,
    start: '08:00',
    end: '17:00'
  }*/],
  existingEvents: [/*{
    start: "2020-07-03T13:00",
    end: "2020-07-03T14:00"
  },{
    start: "2020-07-03T15:00",
    end: "2020-07-03T16:00"
  }*/],
  maxBodyHeight: null,
  onSelect: (date) => console.log(date),
  onMore: () => console.log('more')
}

export default TimeTable
